// @core/api/endpoints/analytics/query_data.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  QueryDataRequest,
  QueryDataResponse,
} from '../../../types/analytics';

const BASE_PATH = '/analytics';

/**
 * Query analytics data
 * Executes an analytics query against product data. Supports aggregation, filtering, grouping, and time series.
 */
export async function QueryData(
  data: QueryDataRequest,
  options?: RequestOptions
): Promise<QueryDataResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/analytics/query`;
  const requestOptions = options;
  return client.post<QueryDataResponse>(requestPath, data, requestOptions);
}
